module.exports = __webpack_public_path__ + "img/KP.3592df46.png";